"use strict";
/* eslint-disable react/prop-types */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var wagtailConfig_1 = require("../../config/wagtailConfig");
var LoadingSpinner_1 = __importDefault(require("../LoadingSpinner/LoadingSpinner"));
var Transition_1 = __importStar(require("../Transition/Transition"));
var PageExplorerHeader_1 = __importDefault(require("./PageExplorerHeader"));
var PageExplorerItem_1 = __importDefault(require("./PageExplorerItem"));
var PageCount_1 = __importDefault(require("./PageCount"));
/**
 * The main panel of the page explorer menu, with heading,
 * menu items, and special states.
 */
var PageExplorerPanel = /** @class */ (function (_super) {
    __extends(PageExplorerPanel, _super);
    function PageExplorerPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            transition: Transition_1.PUSH,
        };
        _this.onItemClick = _this.onItemClick.bind(_this);
        _this.onHeaderClick = _this.onHeaderClick.bind(_this);
        return _this;
    }
    PageExplorerPanel.prototype.componentWillReceiveProps = function (newProps) {
        var depth = this.props.depth;
        var isPush = newProps.depth > depth;
        this.setState({
            transition: isPush ? Transition_1.PUSH : Transition_1.POP,
        });
    };
    PageExplorerPanel.prototype.onItemClick = function (id, e) {
        var gotoPage = this.props.gotoPage;
        e.preventDefault();
        e.stopPropagation();
        gotoPage(id, 1);
    };
    PageExplorerPanel.prototype.onHeaderClick = function (e) {
        var _a;
        var _b = this.props, page = _b.page, depth = _b.depth, gotoPage = _b.gotoPage;
        var parent = (_a = page.meta.parent) === null || _a === void 0 ? void 0 : _a.id;
        // Note: Checking depth as well in case the user started deep in the tree
        if (depth > 0 && parent) {
            e.preventDefault();
            e.stopPropagation();
            gotoPage(parent, -1);
        }
    };
    PageExplorerPanel.prototype.renderChildren = function () {
        var _this = this;
        var _a = this.props, page = _a.page, nodes = _a.nodes;
        var children;
        if (!page.isFetchingChildren && !page.children.items) {
            children = (react_1["default"].createElement("div", { key: "empty", className: "c-page-explorer__placeholder" }, wagtailConfig_1.STRINGS.NO_RESULTS));
        }
        else {
            children = (react_1["default"].createElement("div", { key: "children" }, page.children.items.map(function (id) { return (react_1["default"].createElement(PageExplorerItem_1["default"], { key: id, item: nodes[id], onClick: _this.onItemClick.bind(null, id), navigate: _this.props.navigate })); })));
        }
        return (react_1["default"].createElement("div", { className: "c-page-explorer__drawer" },
            children,
            page.isFetchingChildren || page.isFetchingTranslations ? (react_1["default"].createElement("div", { key: "fetching", className: "c-page-explorer__placeholder" },
                react_1["default"].createElement(LoadingSpinner_1["default"], null))) : null,
            page.isError ? (react_1["default"].createElement("div", { key: "error", className: "c-page-explorer__placeholder" }, wagtailConfig_1.STRINGS.SERVER_ERROR)) : null));
    };
    PageExplorerPanel.prototype.render = function () {
        var _a = this.props, page = _a.page, depth = _a.depth, gotoPage = _a.gotoPage;
        var transition = this.state.transition;
        return (react_1["default"].createElement(Transition_1["default"], { name: transition, className: "c-page-explorer", component: "nav", label: wagtailConfig_1.STRINGS.PAGE_EXPLORER },
            react_1["default"].createElement("div", { key: depth, className: "c-transition-group" },
                react_1["default"].createElement(PageExplorerHeader_1["default"], { depth: depth, page: page, onClick: this.onHeaderClick, gotoPage: gotoPage, navigate: this.props.navigate }),
                this.renderChildren(),
                page.isError || page.children.items && page.children.count > wagtailConfig_1.MAX_EXPLORER_PAGES ? (react_1["default"].createElement(PageCount_1["default"], { page: page })) : null)));
    };
    return PageExplorerPanel;
}(react_1["default"].Component));
exports["default"] = PageExplorerPanel;
